import React, { Component } from 'react'
import {
  Button,
  Container,
  Form,
  FormGroup,
  Label,
  Input
} from 'reactstrap'

class NewsSave extends Component {
  constructor () {
    super()
    this.state = {}

    this.onCancel = this.onCancel.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onSave = this.onSave.bind(this)
  }

  onCancel () {
    this.props.history.push('/admin')
  }

  onChange (el) {
    this.setState({
      [el.target.name]: el.target.value
    })
  }

  async onSave (e) {
    e.preventDefault()
    await this.props.saveNews(this.state)

    this.props.history.push('/admin')
  }

  render () {
    return (
      <Container>
        <h3 className='display-4'>Salvar notícia</h3>
        <Form onSubmit={this.onSave}>
          <FormGroup>
            <Label for='title'>Título</Label>
            <Input type='text' name='title' id='title' required onChange={this.onChange} />
          </FormGroup>
          <FormGroup>
            <Label for='link'>Link</Label>
            <Input type='text' name='link' id='link' required onChange={this.onChange} />
          </FormGroup>
          <FormGroup>
            <Label for='date'>Data</Label>
            <Input type='date' name='date' id='date' required onChange={this.onChange} />
          </FormGroup>
          <div className='clearfix'>
            <Button className='float-left' color='secondary' onClick={this.onCancel}>
              Voltar
            </Button>
            <Button type='submit' className='float-right' color='success'>
              Salvar
            </Button>
          </div>
        </Form>
      </Container>
    )
  }
}

export default NewsSave



// WEBPACK FOOTER //
// ./src/components/templates/Admin/NewsSave/NewsSave.js